export default function addFloorPlan(state, action) {
  const { id, imageSrc, imageSize, location } = action

  return Object.assign({}, state, {
    currentEntity: {
      type: 'floorPlan',
      id
    },
    ui: {
      ...state.ui,
      sidebarView: 'floorPlanDetails'
    },
    map: {
      ...state.map,
      floorPlans: [
        ...state.map.floorPlans,
        { id, imageSrc, imageSize, location, newlyAdded: true, locked: false, opacity: 1, name: `Floor Plan ${id}` }
      ]
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addFloorPlan.js